import { useEffect, useState, useRef } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { Button } from "abs-ui-components";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import RichTextEditor from "../../RichTextEditor/RichTextEditor";

const FuelOilConsumption = ({
  fuelOilConsumptiondescription,
  refetchMonitoringData,
  vesselMstId,
}) => {
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState("");
  const [lastSavedContent, setLastSavedContent] = useState("");
  const [isSavingDescription, setIsSavingDescription] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [error, setError] = useState("");

  // ✅ Check if editor has either text or images
  const hasContent = (html) => {
    if (!html) return false;
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent.trim();
    const hasImage = div.querySelector("img");
    return !!text || !!hasImage;
  };

  // Populate content from prop
  useEffect(() => {
    if (fuelOilConsumptiondescription) {
      setEditorContent(fuelOilConsumptiondescription);
      setLastSavedContent(fuelOilConsumptiondescription);
      setIsDirty(false);
    }
  }, [fuelOilConsumptiondescription]);

  // Handle changes from the editor
  const handleChange = (value) => {
    setEditorContent(value);
    setIsDirty(true);
  };

  const handleSave = async () => {
    if (!editorRef.current) return;
    const editorHTML = editorRef.current.getHTML().trim();

    try {
      setIsSavingDescription(true);
      const res = await callApi({
        method: "POST",
        url: API_ROUTES.FuelOilConsumption(vesselMstId),
        data: JSON.stringify(editorHTML),
        headers: { "Content-Type": "application/json" },
      });

      if (res?.isSuccess) {
        emitToasterMsg("success", "Fuel Oil Consumption", "Saved successfully");
        await refetchMonitoringData?.();
        setError("");
        setEditorContent(editorHTML);
        setLastSavedContent(editorHTML);
        setIsDirty(false); // ✅ reset dirty flag after save
      } else {
        emitToasterMsg("error", "Fuel Oil Consumption", res?.errorMessage);
      }
    } catch (err) {
      emitToasterMsg("error", "Fuel Oil Consumption", err.message);
    } finally {
      setIsSavingDescription(false);
    }
  };

  const isSaveDisabled =
    isSavingDescription || !hasContent(editorContent) || !isDirty;

  return (
    <Box mt={3}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} md={2}>
          <Typography variant="body2" fontWeight={600} mb={1}>
            Description <span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box
            border="1px solid #ccc"
            borderRadius={1}
            p={1}
            sx={{ background: "#fff" }}
          >
            <RichTextEditor
              ref={editorRef}
              value={editorContent}
              onChange={handleChange}
              placeholder="Enter the description for fuel oil consumption..."
            />
          </Box>

          {error && (
            <Typography variant="caption" color="error" mt={1}>
              {error}
            </Typography>
          )}

          <Box mt={2}>
            <Button
              onClick={handleSave}
              disabled={isSaveDisabled}
              size="small"
            >
              Save
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FuelOilConsumption;
